import axios from "axios";

// Core API instance pointing to your FastAPI backend on port 8000
const api = axios.create({
  baseURL: "http://localhost:8000",
  timeout: 60000,
});
// const api = axios.create({
//   baseURL: "https://hrms.gtplindia.com:8443",
//   timeout: 60000, 
// });

/* 🔐 Attach token and required headers for non-auth requests */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    const empCode = localStorage.getItem("emp_code");

    // 🔥 FIX: FORCE ROLE TO UPPERCASE (BACKEND EXPECTS THIS)
    const role = (localStorage.getItem("role") || "EMPLOYEE").toUpperCase();

    // Skip auth endpoints
    if (!config.url.includes("/auth")) {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // ✅ SINGLE SOURCE OF TRUTH: emp_code
      if (empCode) {
        config.headers["X-EMP-CODE"] = empCode;
      }

      // ✅ BACKEND-COMPATIBLE ROLE
      config.headers["X-ROLE"] = role;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* Handle Response Data and Errors */
api.interceptors.response.use(
  (response) => {
    // Return data directly for cleaner consumption in components
    return response.data !== undefined ? response.data : response;
  },
  (error) => {
    console.error('API Interceptor Error:', {
      message: error.message,
      response: error.response,
      responseData: error.response?.data,
      status: error.response?.status,
      url: error.config?.url
    });
    
    // Preserve the full error object but add a readable message
    const message = error.response?.data?.detail || error.response?.data?.message || error.message || "Something went wrong";
    const enhancedError = new Error(message);
    enhancedError.response = error.response;
    enhancedError.originalError = error;
    return Promise.reject(enhancedError);
  }
);

/* ===================================================================
   AUTH SERVICES
   =================================================================== */

/**
 * Handles user login.
 * Checks for must_change_password flag in response.
 */
export const loginSra = async (payload) => {
  return api.post("/auth/login", payload);
};

/**
 * Updates the temporary password to a permanent one.
 * Matches: @router.post("/change-password") in auth.py
 */
export const changePasswordSra = (data) => {
  return api.post("/auth/change-password", data);
};

/**
 * Legacy/Reset password endpoint (if needed for token-based reset)
 */
export const setPasswordSra = (data) => api.post("/auth/set-password", data);

// Registration for Super Admin
export const registerSuperAdmin = (data) =>
  api.post("/auth/super-admin/register", data);

/* ===================================================================
   ADMIN & EMPLOYEE SERVICES
   =================================================================== */

/**
 * Creates a new employee (Onboarding).
 * This triggers the DB save and the welcome email logic.
 */
export const createEmployee = (data) =>
  api.post("/admin/create-employee", data);

/**
 * Fetches the list of all employees.
 */
export const getAllEmployeesList = () =>
  api.get("/admin/employees");

export default api;
